import { useEffect, useState } from "react";
import Twemoji from "react-twemoji";
import settings from "settings";
import TeamDisplayName from "components/TeamDisplayName";
import Tooltip from "components/Tooltip";
import {
  useLeaderboardNumSolves,
  useNumTotalHintTokens,
  useNumUsedHintTokens,
} from "stores/ScopeStateStore";
import {
  useServerInteractionStore,
  useTeamId,
} from "stores/ServerInteractionStore";

function NavTeamName() {
  const sockClient = useServerInteractionStore(
    (state) => state.getSockClient
  )();
  const teamId = useTeamId();
  const numSolves = useLeaderboardNumSolves();
  const numTotalHintTokens = useNumTotalHintTokens(teamId);
  const numUsedHintTokens = useNumUsedHintTokens(teamId);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    return sockClient?.addAuthEffect(() => {
      setConnected(true);
      return () => {
        setConnected(false);
      };
    });
  }, [sockClient]);

  if (
    teamId === null ||
    numTotalHintTokens === null ||
    numUsedHintTokens === null ||
    numSolves === null
  )
    return null;

  return (
    <>
      {!settings.localMode ? (
        <Tooltip
          text={
            connected ? "Connected" : "Disconnected; attempting to reconnect..."
          }
        >
          <div className="nav-stat">
            <Twemoji tag="span">{connected ? "🟢️" : "🟡️"}</Twemoji>
            &nbsp;{connected ? "Connected" : "Disconnected"}
          </div>
        </Tooltip>
      ) : null}
      <TeamDisplayName hideAdminLinks={true} />
      {numTotalHintTokens === 0 && numSolves === 0 ? null : (
        <div className="nav-stats">
          {numTotalHintTokens === 0 ? null : (
            <Tooltip text="Hints available">
              {numTotalHintTokens - numUsedHintTokens}
              <Twemoji tag="small">🍞️</Twemoji>
            </Tooltip>
          )}
          {numSolves === 0 ? null : (
            <Tooltip text="Puzzles solved">
              {numSolves}
              <Twemoji tag="small">✅️</Twemoji>
            </Tooltip>
          )}
        </div>
      )}
    </>
  );
}

export default NavTeamName;
